import { loadable } from '../../common/utils/lazyLoading';
import getMyProfileStructure from './common/getMyProfileStructure';

const MyProfileStructure = loadable(() => import('./MyProfileStructure'));

export default {
  id: 'my_profile',
  title: 'My Profile',
  icon: 'profile',
  route: 'profile',
  defaultRoute: 'profile/my-profile',
  component: MyProfileStructure,
  isPermissionCheckSkipped: true,
  hasDynamicDefaultRoute: true,
  structure: getMyProfileStructure(),
};
